const positiveSpace = {
  tiny: 2,
  '2x_small': 4,
  '1x_small': 8,
  small: 12,
  base: 16,
  big: 24,
  '1x_big': 32,
  '2x_big': 40,
  '3x_big': 48,
  huge: 64,
  '1x_huge': 72,
  '2x_huge': 96,
} as const;

export const space = Object.entries(positiveSpace).reduce(
  (space, [key, value]) => {
    space[key] = value;
    space[`minus_${key}`] = -value;
    return space;
  },
  {}
);
